/**
 * Contexto de sessão. Pergunta /auth/me uma vez ao carregar e guarda quem é.
 * As telas e as guardas de rota leem daqui.
 */
import { createContext, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import type { SessionDTO } from "@unik/shared";
import { api, ApiClientError } from "./api";

interface SessionState {
  session: SessionDTO | null;
  loading: boolean;
  setSession: (s: SessionDTO | null) => void;
  refresh: () => Promise<void>;
}

const SessionContext = createContext<SessionState | null>(null);

export function SessionProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<SessionDTO | null>(null);
  const [loading, setLoading] = useState(true);

  async function refresh(): Promise<void> {
    try {
      setSession(await api.get<SessionDTO>("/auth/me"));
    } catch (err) {
      // 401 (sem sessão) é o caso normal em página pública — não é erro de verdade.
      if (!(err instanceof ApiClientError)) console.error(err);
      setSession(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void refresh();
  }, []);

  return (
    <SessionContext.Provider value={{ session, loading, setSession, refresh }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession(): SessionState {
  const ctx = useContext(SessionContext);
  if (ctx === null) throw new Error("useSession precisa estar dentro de <SessionProvider>.");
  return ctx;
}
